import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  transform: "translate(4 3)"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "16",
    height: "10.353",
    y: "8.493",
    rx: "1"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    d: "M3.294 8.47V4.709C3.292 2.292 5.14.267 7.57.024s4.65 1.376 5.136 3.743M8 12.235v2.824"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }